import dayjs from "dayjs"
import { ImageView } from "./common"

export interface ProfileUnreadableCorporationView {
  names: string[]
}

export interface UserProfileExperienceCorporationView {
  corporationName: string
  leadingCompanyId: string | null
  isLeadingCompany: boolean
  leadingCompanyLogoImage: ImageView
  joinReason: string | null
  isCurrentCorporation: boolean
  workSpan: {
    startYear: number
    startMonth: number
    endYear: number | null
    endMonth: number | null
  }
  experiencedProjects: UserProfileExperienceProjectView[]
}

export interface UserProfileExperienceProjectView {
  achievedContent: string | null
  name: string
  personnelScaleId: number | null
  personnelScaleName: string | null
  relatedUrl: string | null
  role: string
  workContent: string
}

const getDurationText = (
  startYear: number,
  startMonth: number,
  endYear: number | null,
  endMonth: number | null
) => {
  const endDayjs =
    !endYear && !endMonth ? dayjs() : dayjs(`${endYear}${endMonth}`)
  const startDayjs = dayjs(`${startYear}${startMonth}`)

  const diffInMonth = endDayjs.diff(startDayjs, "month")

  const durationYear = Math.floor(diffInMonth / 12)
  const durationMonth = diffInMonth % 12

  if (durationYear === 0) {
    return `${durationMonth}ヶ月`
  } else if (durationMonth === 0) {
    return `${durationYear}年`
  }

  return `${durationYear}年${durationMonth}ヶ月`
}

export const decorateUserProfileExperienceCorporationView = (
  view: UserProfileExperienceCorporationView
) => ({
  getWorkSpanText: (): string => {
    const { startYear, startMonth, endYear, endMonth } = view.workSpan

    const durationText = getDurationText(
      startYear,
      startMonth,
      endYear,
      endMonth
    )

    if (startYear && startMonth && endYear && endMonth) {
      return `${startYear}年${startMonth}月-${endYear}年${endMonth}月 (${durationText})`
    } else if (startYear && startMonth && view.isCurrentCorporation) {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      return `${startYear}年${startMonth}月-${year}年${month}月現在 (${durationText})`
    }

    return ""
  },
})
